import React from "react";

function CompleteTick() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM9 15.6C10.7504 15.6 12.4292 14.9046 13.6669 13.6669C14.9046 12.4292 15.6 10.7504 15.6 9C15.6 7.24957 14.9046 5.57084 13.6669 4.3331C12.4292 3.09535 10.7504 2.4 9 2.4C7.24957 2.4 5.57084 3.09535 4.3331 4.3331C3.09535 5.57084 2.4 7.24957 2.4 9C2.4 10.7504 3.09535 12.4292 4.3331 13.6669C5.57084 14.9046 7.24957 15.6 9 15.6ZM8.121 10.9185L12.4777 6.5625L13.1138 7.19925L8.65125 11.6617C8.5106 11.8024 8.31987 11.8813 8.121 11.8813C7.92213 11.8813 7.7314 11.8024 7.59075 11.6617L5.25 9.3195L5.88675 8.68275L8.12175 10.9178L8.121 10.9185Z"
        fill="white"
      />
    </svg>
  );
}

export default CompleteTick;
